import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  Button,
  TextField,
  InputAdornment,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Breadcrumbs,
  Link,
  Stack,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import {
  Search,
  LocationOn,
  Business,
  Schedule,
  AttachMoney,
  NavigateNext,
  Home,
  Work,
  Category,
  Public,
  Email,
  Link as LinkIcon,
} from "@mui/icons-material";
import { IonPage } from "@ionic/react";
import { getAllCompanyJobs } from "../../../api/jobs/jobs";
import { useHistory } from "react-router";

// Mock data based on your schema
const mockJobAdverts = [
  {
    id: 1,
    job_id: "DEV-001",
    title: "Senior Frontend Developer",
    description:
      "We are looking for an experienced Frontend Developer to join our innovative team. You will be responsible for developing user-facing features using modern JavaScript frameworks.",
    status: "active",
    expiration_date: "2024-03-15",
    batch_id: "BATCH-2024-01",
    business_id: "BUS-001",
    branch_id: "BRANCH-NY",
    created_at: "2024-01-15",
    job_type: "Full-time",
    category: "Engineering",
    summary:
      "Join our engineering team to build cutting-edge web applications.",
    responsibilities: [
      "Develop new user-facing features",
      "Build reusable components and front-end libraries",
      "Optimize applications for maximum performance",
      "Collaborate with back-end developers and web designers",
    ],
    requirements: [
      "5+ years of experience with React",
      "Proficient in TypeScript",
      "Experience with state management libraries",
      "Knowledge of modern build tools",
    ],
    qualifications: [
      "Bachelor's degree in Computer Science or related field",
      "Strong problem-solving skills",
      "Excellent communication abilities",
    ],
    benefits: [
      "Health insurance",
      "Flexible working hours",
      "Remote work options",
      "Professional development budget",
    ],
    min_salary: 90000,
    max_salary: 120000,
    company_name: "Tech Solutions Inc.",
    website: "https://techsolutions.com",
    company_description:
      "A leading technology company specializing in enterprise software solutions with over 10 years of industry experience.",
    application_email: "careers@techsolutions.com",
    application_link: "https://techsolutions.com/careers/apply",
  },
  {
    id: 2,
    job_id: "DSGN-002",
    title: "UX/UI Designer",
    description:
      "Join our design team to create amazing user experiences and beautiful interfaces for our products.",
    status: "active",
    expiration_date: "2024-03-10",
    batch_id: "BATCH-2024-01",
    business_id: "BUS-001",
    branch_id: "BRANCH-REMOTE",
    created_at: "2024-01-10",
    job_type: "Full-time",
    category: "Design",
    summary: "Create user-centered designs for our digital products.",
    responsibilities: [
      "Create wireframes, prototypes, and high-fidelity designs",
      "Conduct user research and usability testing",
      "Collaborate with product managers and developers",
      "Maintain design systems and guidelines",
    ],
    requirements: [
      "3+ years of UX/UI design experience",
      "Proficient in Figma and Adobe Creative Suite",
      "Experience with user research methodologies",
      "Portfolio demonstrating design process",
    ],
    qualifications: [
      "Degree in Design, HCI, or related field",
      "Understanding of front-end development principles",
      "Strong visual design skills",
    ],
    benefits: [
      "Competitive salary",
      "Health and dental insurance",
      "Flexible schedule",
      "Annual design conference budget",
    ],
    min_salary: 70000,
    max_salary: 90000,
    company_name: "Tech Solutions Inc.",
    website: "https://techsolutions.com",
    company_description:
      "A leading technology company specializing in enterprise software solutions.",
    application_email: "design-jobs@techsolutions.com",
    application_link: "https://techsolutions.com/careers/design-apply",
  },
];

const CompanyCareerPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedJobType, setSelectedJobType] = useState("all");
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobDialogOpen, setJobDialogOpen] = useState(false);

  const history = useHistory()

  // Fetch jobs from API
  const fetchJobs = async () => {
    try {

      const data = {
        business_id:"bus_id_39683d07fafb3f673a4f16cc6c37773f"
      }
      setLoading(true);
      // Replace with actual API call
      const response = await getAllCompanyJobs(data);
      // const result = await response.data;
      // console.log(response.data );
      // const data = await response.json();

      setTimeout(() => {
        setJobs(response.data);
        setLoading(false);
      }, 1000);
    } catch (err) {
      setError("Failed to load job openings");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  // Get unique categories and job types for filters
  const categories = ["all", ...new Set(jobs.map((job) => job.category))];
  const jobTypes = ["all", ...new Set(jobs.map((job) => job.job_type))];

  // Filter jobs based on search and filters
  const filteredJobs = jobs.filter((job) => {
    const matchesSearch =
      job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.summary.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || job.category === selectedCategory;
    const matchesJobType =
      selectedJobType === "all" || job.job_type === selectedJobType;

    return matchesSearch && matchesCategory && matchesJobType;
  });

  const handleViewJobDetails = (job) => {
    setSelectedJob(job);
    setJobDialogOpen(true);
  };

const handleApplyNow = (job) => {
  if (job.application_link) {
    history.push(`/folder/apply/${job.application_link}`); 
  } else if (job.application_email) {
    window.location.href = `mailto:${job.application_email}?subject=Application for ${job.title}`;
  }
};


  const formatSalary = (min, max) => {
    return `$${min.toLocaleString()} - $${max.toLocaleString()}`;
  };

  const isJobExpiringSoon = (expirationDate) => {
    const expDate = new Date(expirationDate);
    const today = new Date();
    const diffTime = expDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7 && diffDays > 0;
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <IonPage>
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        {/* Hero Section */}
        <Paper
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            py: 8,
            mb: 4,
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                sx={{ fontWeight: "bold" }}
              >
                Join Our Team
              </Typography>
              <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
                Build your career with {jobs[0]?.company_name || "Our Company"}
              </Typography>
              <Typography
                variant="body1"
                sx={{ maxWidth: "600px", margin: "0 auto", opacity: 0.8 }}
              >
                {jobs[0]?.company_description ||
                  "We are looking for talented individuals to join our growing team."}
              </Typography>
            </Box>
          </Container>
        </Paper>

        <Container maxWidth="lg">
          {/* Breadcrumbs */}
          <Breadcrumbs
            separator={<NavigateNext fontSize="small" />}
            sx={{ mb: 3 }}
          >
            <Link
              color="inherit"
              href="/"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Home sx={{ mr: 0.5 }} fontSize="small" />
              Home
            </Link>
            <Typography
              color="text.primary"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Work sx={{ mr: 0.5 }} fontSize="small" />
              Careers
            </Typography>
          </Breadcrumbs>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          {/* Search and Filters */}
          <Card sx={{ mb: 4 }}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    placeholder="Search jobs by title, description..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    select
                    label="Category"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Category />
                        </InputAdornment>
                      ),
                    }}
                  >
                    {categories.map((category) => (
                      <MenuItem key={category} value={category}>
                        {category === "all" ? "All Categories" : category}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    select
                    label="Job Type"
                    value={selectedJobType}
                    onChange={(e) => setSelectedJobType(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Work />
                        </InputAdornment>
                      ),
                    }}
                  >
                    {jobTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type === "all" ? "All Types" : type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Results Count */}
          <Typography variant="h6" sx={{ mb: 2 }}>
            {filteredJobs.length} Job Opening
            {filteredJobs.length !== 1 ? "s" : ""} Available
          </Typography>

          {/* Job Listings */}
          <Grid container spacing={3}>
            {filteredJobs.length === 0 ? (
              <Grid item xs={12}>
                <Card>
                  <CardContent sx={{ textAlign: "center", py: 6 }}>
                    <Typography variant="h6" color="text.secondary">
                      No job openings found
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Try adjusting your search criteria or check back later for
                      new opportunities.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              filteredJobs.map((job) => (
                <Grid item xs={12} key={job.id}>
                  <Card
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: 3,
                      },
                    }}
                  >
                    <CardContent>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={8}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography
                              variant="h5"
                              component="h2"
                              sx={{ fontWeight: "bold", mr: 2 }}
                            >
                              {job.title}
                            </Typography>
                            {isJobExpiringSoon(job.expiration_date) && (
                              <Chip
                                label="Expiring Soon"
                                color="warning"
                                size="small"
                              />
                            )}
                          </Box>

                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}
                          >
                            <Chip
                              icon={<Business />}
                              label={job.company_name}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              icon={<LocationOn />}
                              label={job.branch_id.replace("BRANCH-", "")}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              icon={<Schedule />}
                              label={job.job_type}
                              color="primary"
                              size="small"
                            />
                            <Chip
                              icon={<AttachMoney />}
                              label={formatSalary(
                                job.min_salary,
                                job.max_salary
                              )}
                              variant="outlined"
                              size="small"
                            />
                            <Chip
                              label={job.category}
                              variant="outlined"
                              size="small"
                            />
                          </Stack>

                          <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ mb: 2 }}
                          >
                            {job.summary}
                          </Typography>

                          <Typography variant="body2" color="text.secondary">
                            Posted:{" "}
                            {new Date(job.created_at).toLocaleDateString()} •
                            Expires:{" "}
                            {new Date(job.expiration_date).toLocaleDateString()}{" "}
                            • ID: {job.job_id}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <Stack spacing={2}>
                            <Button
                              variant="contained"
                              size="large"
                              fullWidth
                              onClick={() => handleViewJobDetails(job)}
                            >
                              View Details
                            </Button>
                            <Button
                              variant="outlined"
                              size="large"
                              fullWidth
                              onClick={() => handleApplyNow(job)}
                            >
                              Apply Now
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>

          {/* Job Detail Dialog */}
          <Dialog
            open={jobDialogOpen}
            onClose={() => setJobDialogOpen(false)}
            maxWidth="md"
            fullWidth
            scroll="paper"
          >
            {selectedJob && (
              <>
                <DialogTitle>
                  <Typography variant="h4" component="h2" gutterBottom>
                    {selectedJob.title}
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                    <Chip
                      icon={<Business />}
                      label={selectedJob.company_name}
                    />
                    <Chip
                      icon={<LocationOn />}
                      label={selectedJob.branch_id.replace("BRANCH-", "")}
                    />
                    <Chip
                      icon={<Work />}
                      label={selectedJob.job_type}
                      color="primary"
                    />
                    <Chip icon={<Category />} label={selectedJob.category} />
                    <Chip
                      icon={<AttachMoney />}
                      label={formatSalary(
                        selectedJob.min_salary,
                        selectedJob.max_salary
                      )}
                    />
                  </Stack>
                </DialogTitle>

                <DialogContent dividers>
                  <Stack spacing={3}>
                    {/* Job Summary */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Job Summary
                      </Typography>
                      <Typography variant="body1">
                        {selectedJob.summary}
                      </Typography>
                    </Box>

                    {/* Description */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Job Description
                      </Typography>
                      <Typography variant="body1">
                        {selectedJob.description}
                      </Typography>
                    </Box>

                    {/* Responsibilities */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Key Responsibilities
                      </Typography>
                      <List dense>
                        {selectedJob.responsibilities.map((resp, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>•</ListItemIcon>
                            <ListItemText primary={resp} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>

                    {/* Requirements */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Requirements
                      </Typography>
                      <List dense>
                        {selectedJob.requirements.map((req, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>•</ListItemIcon>
                            <ListItemText primary={req} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>

                    {/* Qualifications */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Qualifications
                      </Typography>
                      <List dense>
                        {selectedJob.qualifications.map((qual, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>•</ListItemIcon>
                            <ListItemText primary={qual} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>

                    {/* Benefits */}
                    <Box>
                      <Typography variant="h6" gutterBottom color="primary">
                        Benefits & Perks
                      </Typography>
                      <List dense>
                        {selectedJob.benefits.map((benefit, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>•</ListItemIcon>
                            <ListItemText primary={benefit} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>

                    {/* Additional Info */}
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2">
                          <strong>Job ID:</strong> {selectedJob.job_id}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Category:</strong> {selectedJob.category}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Type:</strong> {selectedJob.job_type}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body2">
                          <strong>Posted:</strong>{" "}
                          {new Date(
                            selectedJob.created_at
                          ).toLocaleDateString()}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Expires:</strong>{" "}
                          {new Date(
                            selectedJob.expiration_date
                          ).toLocaleDateString()}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Location:</strong>{" "}
                          {selectedJob.branch_id.replace("BRANCH-", "")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </DialogContent>

                <DialogActions sx={{ p: 3, gap: 2 }}>
                  <Button
                    onClick={() => setJobDialogOpen(false)}
                    variant="outlined"
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleApplyNow(selectedJob)}
                    startIcon={<Email />}
                    sx={{ minWidth: "120px" }}
                  >
                    Apply Now
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>

          {/* Company Info Footer */}
          <Paper sx={{ mt: 6, p: 4, textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              About {jobs[0]?.company_name || "Our Company"}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 2, maxWidth: "800px", margin: "0 auto" }}
            >
              {jobs[0]?.company_description}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              {jobs[0]?.website && (
                <Button
                  startIcon={<Public />}
                  href={jobs[0]?.website}
                  target="_blank"
                  variant="outlined"
                >
                  Visit Website
                </Button>
              )}
              {jobs[0]?.application_email && (
                <Button
                  startIcon={<Email />}
                  href={`mailto:${jobs[0]?.application_email}`}
                  variant="outlined"
                >
                  Contact Us
                </Button>
              )}
            </Stack>
          </Paper>
        </Container>
      </Box>
    </IonPage>
  );
};

export default CompanyCareerPage;
